import React from 'react';
import { get } from 'lodash';
import PropTypes from 'prop-types';
import { ucwords } from '../helper';

function BusinessInformation({ data, remarks }) {
  
  const businessData = get(data, 'ebplsBusiness') || {};
  const details = get(data, 'ebplsBusiness.attributes.details') || {};

  return (
    <div className="p-3">
      <table className="transaction-table table table-striped table-borderless table-sm">
        <tbody>
          <tr>
            <td className="text-dark font-weight-bold" width="250">
              Tracking No.
            </td>
            <td className="text-dark font-weight-bold" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(data, 'ebplsApplication.attributes.tracking_number') || '-'}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark font-weight-bold" width="250">
              Business ID
            </td>
            <td className="text-dark font-weight-bold" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(data, 'ebplsApplication.attributes.bin')  || '-'}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark font-weight-bold" width="250">
              Philippine Standard Industrial Code
            </td>
            <td className="text-dark font-weight-bold" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(businessData, 'attributes.philippine_industrial_code') || '-'}</b>
            </td>
          </tr>
          <tr className="bg-white">
            <td className="min-h-6 bg-white" colSpan={12}>
              <hr />
            </td>
          </tr>
          <tr>
            <td className="cms-text-primary cms-bg-color-primary-light" colSpan={12}>
              <b>Business Details</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark font-weight-bold" width="250">
              Business Type
            </td>
            <td className="text-dark font-weight-bold" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(businessData, 'attributes.business_type') || '-'}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark font-weight-bold" width="250">
              DTI/SEC/CDA Registration No.
            </td>
            <td className="text-dark font-weight-bold" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(businessData, 'attributes.dti_sec_cda_no') || '-'}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark font-weight-bold" width="250">
              Date Issued:
            </td>
            <td className="text-dark font-weight-bold" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(businessData, 'attributes.date_issued') || '-'}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark font-weight-bold" width="250">
              Date Established:
            </td>
            <td className="text-dark font-weight-bold" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(businessData, 'attributes.date_establish') || '-'}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark font-weight-bold" width="250">
              TIN
            </td>
            <td className="text-dark font-weight-bold" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(businessData, 'attributes.tin') || '-'}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark font-weight-bold" width="250">
              Business Name
            </td>
            <td className="text-dark font-weight-bold" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(businessData, 'attributes.business_name') || '-'}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark font-weight-bold" width="250">
              Trade Name/Franchise (if applicable)
            </td>
            <td className="text-dark font-weight-bold" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(businessData, 'attributes.trade_name') || '-'}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark font-weight-bold" width="250">
              Kind
            </td>
            <td className="text-dark font-weight-bold" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(businessData, 'attributes.kind') || '-'}</b>
            </td>
          </tr>
          <tr className="bg-white">
            <td className="min-h-6 bg-white">
              <br />
            </td>
          </tr>
          <tr>
            <td className="cms-text-primary cms-bg-color-primary-light" colSpan={12}>
              <b>Main Office Address</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark font-weight-bold" width="250">
              Region
            </td>
            <td className="text-dark font-weight-bold" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(businessData, 'attributes.main_office_address.region_name') || '-'}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark font-weight-bold" width="250">
              Province
            </td>
            <td className="text-dark font-weight-bold" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(businessData, 'attributes.main_office_address.province_name') || '-'}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark font-weight-bold" width="250">
              City/Municipality
            </td>
            <td className="text-dark font-weight-bold" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(businessData, 'attributes.main_office_address.municipality_name') || '-'}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark font-weight-bold" width="250">
              ZIP Code
            </td>
            <td className="text-dark font-weight-bold" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(businessData, 'attributes.main_office_address.zip_code') || '-'}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark font-weight-bold" width="250">
              Barangay
            </td>
            <td className="text-dark font-weight-bold" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(businessData, 'attributes.main_office_address.barangay_name') || '-'}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark font-weight-bold" width="250">
              Street
            </td>
            <td className="text-dark font-weight-bold" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(businessData, 'attributes.main_office_address.street') || '-'}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark font-weight-bold" width="250">
              Subdivision
            </td>
            <td className="text-dark font-weight-bold" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(businessData, 'attributes.main_office_address.subdivision') || '-'}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark font-weight-bold" width="250">
              Block No.
            </td>
            <td className="text-dark font-weight-bold" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(businessData, 'attributes.main_office_address.block_no') || '-'}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark font-weight-bold" width="250">
              Lot No.
            </td>
            <td className="text-dark font-weight-bold" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(businessData, 'attributes.main_office_address.lot_no') || '-'}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark font-weight-bold" width="250">
              Name of Building
            </td>
            <td className="text-dark font-weight-bold" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(businessData, 'attributes.main_office_address.building_name') || '-'}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark font-weight-bold" width="250">
              House/Bldg. No.
            </td>
            <td className="text-dark font-weight-bold" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(businessData, 'attributes.main_office_address.house_bldg_no') || '-'}</b>
            </td>
          </tr>
          <tr className="bg-white">
            <td className="min-h-6 bg-white">
              <br />
            </td>
          </tr>
          <tr>
            <td className="cms-text-primary cms-bg-color-primary-light" colSpan={12}>
              <b>Business Address</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark font-weight-bold" width="250">
              Region
            </td>
            <td className="text-dark font-weight-bold" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(businessData, 'attributes.business_address.region_name') || '-'}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark font-weight-bold" width="250">
              Province
            </td>
            <td className="text-dark font-weight-bold" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(businessData, 'attributes.business_address.province_name') || '-'}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark font-weight-bold" width="250">
              City/Municipality
            </td>
            <td className="text-dark font-weight-bold" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(businessData, 'attributes.business_address.municipality_name') || '-'}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark font-weight-bold" width="250">
              ZIP Code
            </td>
            <td className="text-dark font-weight-bold" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(businessData, 'attributes.business_address.zip_code') || '-'}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark font-weight-bold" width="250">
              Barangay
            </td>
            <td className="text-dark font-weight-bold" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(businessData, 'attributes.business_address.barangay_name') || '-'}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark font-weight-bold" width="250">
              Street
            </td>
            <td className="text-dark font-weight-bold" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(businessData, 'attributes.business_address.street') || '-'}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark font-weight-bold" width="250">
              Subdivision
            </td>
            <td className="text-dark font-weight-bold" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(businessData, 'attributes.business_address.subdivision') || '-'}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark font-weight-bold" width="250">
              Block No.
            </td>
            <td className="text-dark font-weight-bold" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(businessData, 'attributes.business_address.block_no') || '-'}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark font-weight-bold" width="250">
              Lot No.
            </td>
            <td className="text-dark font-weight-bold" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(businessData, 'attributes.business_address.lot_no') || '-'}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark font-weight-bold" width="250">
              Name of Building
            </td>
            <td className="text-dark font-weight-bold" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(businessData, 'attributes.business_address.building_name') || '-'}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark font-weight-bold" width="250">
              House/Bldg. No.
            </td>
            <td className="text-dark font-weight-bold" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(businessData, 'attributes.business_address.house_bldg_no') || '-'}</b>
            </td>
          </tr>
          <tr className="bg-white">
            <td className="min-h-6 bg-white" colSpan={12}>
              <hr />
            </td>
          </tr>
          <tr>
            <td className="cms-text-primary cms-bg-color-primary-light" colSpan={12}>
              <b>Business Operations</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark font-weight-bold" width="250">
              Business Area (in sq. m.)
            </td>
            <td className="text-dark font-weight-bold" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(businessData, 'attributes.business_area') || '-'}</b>
            </td>
          </tr>
          <tr className="bg-white">
            <td className="min-h-6 bg-white">
              <br />
            </td>
          </tr>
          <tr>
            <td className="cms-text-primary cms-bg-color-primary-light" colSpan={12}>
              <b>Time of Operation</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark font-weight-bold" width="250">
              From
            </td>
            <td className="text-dark font-weight-bold" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(businessData, 'attributes.operation_start') || '-'}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark font-weight-bold" width="250">
              To
            </td>
            <td className="text-dark font-weight-bold" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(businessData, 'attributes.operation_end') || '-'}</b>
            </td>
          </tr>
          <tr className="bg-white">
            <td className="min-h-6 bg-white">
              <br />
            </td>
          </tr>
          <tr>
            <td className="cms-text-primary cms-bg-color-primary-light" colSpan={12}>
              <b>No. of Employees</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark font-weight-bold" width="250">
              Total No. of Employees in Establishment
            </td>
            <td className="text-dark font-weight-bold" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(businessData, 'attributes.no_of_employees') || '-'}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark font-weight-bold" width="250">
              Total No. of Male Employees
            </td>
            <td className="text-dark font-weight-bold" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(businessData, 'attributes.no_of_male_employees') || '-'}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark font-weight-bold" width="250">
              Total No. of Female Employees
            </td>
            <td className="text-dark font-weight-bold" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(businessData, 'attributes.no_of_female_employees') || '-'}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark font-weight-bold" width="250">
              No. of Employees Residing in Las Pi&#x00f1;as
            </td>
            <td className="text-dark font-weight-bold" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(businessData, 'attributes.no_of_employees_residing') || '-'}</b>
            </td>
          </tr>
          <tr className="bg-white">
            <td className="min-h-6 bg-white">
              <br />
            </td>
          </tr>
          <tr>
            <td className="cms-text-primary cms-bg-color-primary-light" colSpan={12}>
              <b>No. of Delivery Vehicles</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark font-weight-bold" width="250">
              10 Wheeler
            </td>
            <td className="text-dark font-weight-bold" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(businessData, 'attributes.ten_wheelers') || '0'}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark font-weight-bold" width="250">
              6 Wheeler
            </td>
            <td className="text-dark font-weight-bold" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(businessData, 'attributes.six_wheelers') || '0'}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark font-weight-bold" width="250">
              4 Wheeler
            </td>
            <td className="text-dark font-weight-bold" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(businessData, 'attributes.four_wheelers') || '0'}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark font-weight-bold" width="250">
              2 to 3 Wheeler
            </td>
            <td className="text-dark font-weight-bold" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(businessData, 'attributes.two_three_wheelers') || '0'}</b>
            </td>
          </tr>
          <tr className="bg-white">
            <td className="min-h-6 bg-white">
              <br />
            </td>
          </tr>
          <tr>
            <td className="text-dark font-weight-bold" width="250">
              Owned?
            </td>
            <td className="text-dark font-weight-bold" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(businessData, 'attributes.is_owned') ? "Yes" : "No"}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark font-weight-bold" width="250">
              Tax Declaration Number
            </td>
            <td className="text-dark font-weight-bold" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(businessData, 'attributes.tdn') || '-'}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark font-weight-bold" width="250">
              Property Information Number
            </td>
            <td className="text-dark font-weight-bold" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(businessData, 'attributes.pin') || '-'}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark font-weight-bold" width="250">
              Lessor Name
            </td>
            <td className="text-dark font-weight-bold" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(businessData, 'attributes.lessor_name') || '-'}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark font-weight-bold" width="250">
              Monthly Rental
            </td>
            <td className="text-dark font-weight-bold" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(businessData, 'attributes.monthly_rental') || '-'}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark font-weight-bold" width="250">
              Do you have tax incentives from any government entity?
            </td>
            <td className="text-dark font-weight-bold" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(businessData, 'attributes.with_tax_incentives') ? "Yes" : "No"}</b>
            </td>
          </tr>
          <tr className="bg-white">
            <td className="min-h-6 bg-white" colSpan={12}>
              <hr />
            </td>
          </tr>
          <tr className="bg-white">
            <td className="cms-text-primary bg-white" colSpan={12}>
              <b>Owner/President/Officer in Charge&rsquo;s Information</b>
            </td>
          </tr>
          <tr>
            <td className="cms-text-primary cms-bg-color-primary-light" colSpan={12}>
              <b>Name of Owner/President/Officer in Charge</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark font-weight-bold" width="250">
              Last Name
            </td>
            <td className="text-dark font-weight-bold" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(data, 'ebplsBusinessContactPerson.attributes.last_name') || '-'}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark font-weight-bold" width="250">
              First Name
            </td>
            <td className="text-dark font-weight-bold" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(data, 'ebplsBusinessContactPerson.attributes.first_name') || '-'}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark font-weight-bold" width="250">
              Middle Name
            </td>
            <td className="text-dark font-weight-bold" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(data, 'ebplsBusinessContactPerson.attributes.middle_name') || '-'}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark font-weight-bold" width="250">
              Suffix
            </td>
            <td className="text-dark font-weight-bold" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(data, 'ebplsBusinessContactPerson.attributes.suffix') || '-'}</b>
            </td>
          </tr>
          <tr className="bg-white">
            <td className="min-h-6 bg-white">
              <br />
            </td>
          </tr>
          <tr>
            <td className="text-dark font-weight-bold" width="250">
              Designation/Position/Title
            </td>
            <td className="text-dark font-weight-bold" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(data, 'ebplsBusinessContactPerson.attributes.designation') || '-'}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark font-weight-bold" width="250">
              Gender
            </td>
            <td className="text-dark font-weight-bold" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(data, 'ebplsBusinessContactPerson.attributes.gender') || '-'}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark font-weight-bold" width="250">
              Nationality
            </td>
            <td className="text-dark font-weight-bold" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(data, 'ebplsBusinessContactPerson.attributes.nationality') || '-'}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark font-weight-bold" width="250">
              Civil Status
            </td>
            <td className="text-dark font-weight-bold" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(data, 'ebplsBusinessContactPerson.attributes.civil_status') || '-'}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark font-weight-bold" width="250">
              Date of Birth
            </td>
            <td className="text-dark font-weight-bold" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(data, 'ebplsBusinessContactPerson.attributes.birth_date') || '-'}</b>
            </td>
          </tr>
          <tr className="bg-white">
            <td className="min-h-6 bg-white">
              <br />
            </td>
          </tr>
          <tr>
            <td className="cms-text-primary cms-bg-color-primary-light" colSpan={12}>
              <b>Contact Details</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark font-weight-bold" width="250">
              Mobile No.
            </td>
            <td className="text-dark font-weight-bold" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(data, 'ebplsBusinessContactPerson.attributes.mobile_number') || '-'}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark font-weight-bold" width="250">
              Telephone No.
            </td>
            <td className="text-dark font-weight-bold" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(data, 'ebplsBusinessContactPerson.attributes.telephone_number') || '-'}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark font-weight-bold" width="250">
              Email
            </td>
            <td className="text-dark font-weight-bold" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(data, 'ebplsBusinessContactPerson.attributes.email_address') || '-'}</b>
            </td>
          </tr>
          <tr className="bg-white">
            <td className="min-h-6 bg-white">
              <br />
            </td>
          </tr>
          <tr>
            <td className="cms-text-primary cms-bg-color-primary-light" colSpan={12}>
              <b>Residential Address</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark font-weight-bold" width="250">
              House/Bldg. No.
            </td>
            <td className="text-dark font-weight-bold" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(data, 'ebplsBusinessContactPerson.attributes.house_bldg_no') || '-'}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark font-weight-bold" width="250">
              Name of Building
            </td>
            <td className="text-dark font-weight-bold" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(data, 'ebplsBusinessContactPerson.attributes.building_name') || '-'}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark font-weight-bold" width="250">
              Block No.
            </td>
            <td className="text-dark font-weight-bold" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(data, 'ebplsBusinessContactPerson.attributes.block_no') || '-'}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark font-weight-bold" width="250">
              Lot No.
            </td>
            <td className="text-dark font-weight-bold" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(data, 'ebplsBusinessContactPerson.attributes.lot_no') || '-'}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark font-weight-bold" width="250">
              Street
            </td>
            <td className="text-dark font-weight-bold" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(data, 'ebplsBusinessContactPerson.attributes.street') || '-'}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark font-weight-bold" width="250">
              Subdivision
            </td>
            <td className="text-dark font-weight-bold" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(data, 'ebplsBusinessContactPerson.attributes.subdivision') || '-'}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark font-weight-bold" width="250">
              Barangay
            </td>
            <td className="text-dark font-weight-bold" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(data, 'ebplsBusinessContactPerson.attributes.barangay_name') || '-'}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark font-weight-bold" width="250">
              City/Municipality
            </td>
            <td className="text-dark font-weight-bold" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(data, 'ebplsBusinessContactPerson.attributes.municipality_name') || '-'}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark font-weight-bold" width="250">
              Province
            </td>
            <td className="text-dark font-weight-bold" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(data, 'ebplsBusinessContactPerson.attributes.province_name') || '-'}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark font-weight-bold" width="250">
              ZIP Code
            </td>
            <td className="text-dark font-weight-bold" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(data, 'ebplsBusinessContactPerson.attributes.zip_code') || '-'}</b>
            </td>
          </tr>
          <tr className="bg-white">
            <td className="min-h-6 bg-white">
              <br />
            </td>
          </tr>
          <tr>
            <td className="text-dark font-weight-bold" width="250">
              For Corporation
            </td>
            <td className="text-dark font-weight-bold" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(data, 'ebplsBusinessContactPerson.attributes.for_corporation') || '-'}</b>
            </td>
          </tr>
          <tr className="bg-white">
            <td className="min-h-6 bg-white">
              <br />
            </td>
          </tr>
          <tr>
            <td className="cms-text-primary cms-bg-color-primary-light" colSpan={12}>
              <b>Government IDs</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark font-weight-bold" width="250">
              TIN
            </td>
            <td className="text-dark font-weight-bold" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(data, 'ebplsBusinessContactPerson.attributes.tin') || '-'}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark font-weight-bold" width="250">
              Pag-IBIG ID No.
            </td>
            <td className="text-dark font-weight-bold" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(data, 'ebplsBusinessContactPerson.attributes.pagibig_no') || '-'}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark font-weight-bold" width="250">
              Philhealth ID No.
            </td>
            <td className="text-dark font-weight-bold" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(data, 'ebplsBusinessContactPerson.attributes.philhealth_no') || '-'}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark font-weight-bold" width="250">
              GSIS ID No.
            </td>
            <td className="text-dark font-weight-bold" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(data, 'ebplsBusinessContactPerson.attributes.gsis_id_no') || '-'}</b>
            </td>
          </tr>
          {Object.entries(details).map(item => {
            return (
              <tr key={`bpls_business_detail${item[0]}`}>
                <td className="text-dark font-weight-bold" width="250">
                  {ucwords(item[0].replace(/_/g, ' '))}
                </td>
                <td className="text-dark font-weight-bold" width="1">
                  :
                </td>
                <td colSpan={4}>
                  <b>{item[1] || '-'}</b>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>

      <hr className="ct-hr" />
      <table className="w-100 transaction-table table table-borderless table-sm table-striped table-hover">
        <tbody>
          <tr />
          <tr className="">
            <td className="text-success" colSpan={3}>
              <div className="d-flex justify-content-between align-items-center mb-2">
                <b>REMARKS</b>
              </div>
            </td>
          </tr>
          <tr>
            <td colSpan={5}>
              <div className="w-100 my-2 p-2">
                <b className="text-wrap text-break">
                  {get(
                    remarks,
                    'ebplsApplication.attributes.remarks'
                  ) || '--'}
                </b>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}

BusinessInformation.defaultProps = {
  data: {},
};

BusinessInformation.propTypes = {
  data: PropTypes.instanceOf(Object),
  remarks: PropTypes.instanceOf(Object).isRequired,
};

export default BusinessInformation;
